// types
import { Utilization } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Chip, ChipProps, Tooltip } from '@mui/material';

// ui
import { Loading } from '../Loading/Loading';

// utils
import { formatPercentage } from '../../../utils/format';
import { formatCurrency } from '../../../utils/currency';

// props
export interface ChipUtilizationProps {
	isLoading?: boolean;
	utilization?: Utilization;
}

export const ChipUtilization = ({ isLoading, utilization }: ChipUtilizationProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	let color: ChipProps['color'] = 'default';
	let isIndeterminate = false;
	let title;
	let value = 0;

	if (utilization) {
		if (typeof utilization.value === 'number') {
			value = utilization.value;

			if (utilization.value <= 30) {
				color = 'error';
			} else if (utilization.value > 30 && utilization.value < 70) {
				color = 'warning';
			} else if (utilization.value > 100) {
				color = 'default';
				isIndeterminate = true;
			} else {
				color = 'success';
			}
		}

		if (isIndeterminate) {
			title = t('utilization.title.indeterminate');
		} else {
			title = t('xofYExpensed', {
				disbursed: formatCurrency({
					currency: utilization?.currency,
					notation: 'compact',
					value: utilization?.in?.total || 0,
				}),
				expensed: formatCurrency({
					currency: utilization?.currency,
					notation: 'compact',
					value: utilization?.out?.total || 0,
				}),
			});
		}
	}

	let label = formatPercentage(value);

	if (isIndeterminate) {
		label = t('na');
	}

	const chip = <Chip color={color} label={label} size="small" variant="twoTone" />;

	if (isLoading) {
		return <Loading size="xs" />;
	}

	if (title) {
		return (
			<Tooltip arrow={true} placement="top" title={title}>
				{chip}
			</Tooltip>
		);
	}

	return chip;
};
